export default __webpack_public_path__ + "static/animation_500_l0rivgek-288396f2ac98062f4086e4b60eb3e650.gif";